import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { jsx as t } from "react/jsx-runtime";
import { calculateRem as e, withVDSManager as r } from "@vds-core/utilities";
import { ColorTokens as n } from "@vds-tokens/color";
import o from "styled-components";
var i = o.div.withConfig({
    displayName: "StyledLine",
    componentId: "VDS__sc-132w3tr-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: ", ";\n  width: ", ";\n  background-color: ", ";\n"])), function (_ref) {
    var t = _ref.orientation;
    return "vertical" === t ? "unset" : e("1px");
  }, function (_ref2) {
    var t = _ref2.orientation;
    return "vertical" === t ? e("1px") : "100%";
  }, function (_ref3) {
    var t = _ref3.type,
      e = _ref3.surface;
    return function (t, e) {
      var r = n.elements.primary.onlight.value;
      return "accent" === t ? r = "#d52b1e" : "dark" === e || "xLight" !== t && "secondary" !== t ? "dark" !== e || "xLight" !== t && "secondary" !== t ? "dark" === e && (r = n.elements.primary.ondark.value) : r = n.elements.lowcontrast.ondark.value : r = n.elements.lowcontrast.onlight.value, r;
    }(t, e);
  }),
  a = function a(e) {
    var r = e.surface,
      n = e.id,
      o = e.orientation,
      a = e.type;
    return t(i, Object.assign({}, e, {
      id: n,
      type: a,
      surface: r,
      orientation: o
    }));
  };
a.defaultProps = {
  type: "primary",
  surface: "light",
  orientation: "horizontal"
};
var c = r(a);
export { c as default };